import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./ActionSubmit.module.scss"
import { useFormContext } from "src/inputs/Form"

// maps a key to a style class in ActionSubmit.module.scss
enum StylePreset {
  primary = "actionSubmitPrimary",
  secondary = "actionSubmitSecondary",
  destructive = "actionSubmitDestructive",
}

type StylePresetKey = keyof typeof StylePreset
export const defaultStylePreset: StylePresetKey = "primary"

type InputAttributes = ComponentPropsWithoutRef<"input">

export interface Props extends InputAttributes {
  stylePreset?: StylePresetKey;
}

/*
 * renders an input element submit button that looks like an ActionButton
 * itwill automatically be disabled if contained within an invalid form
 */
export const ActionSubmit = forwardRef<HTMLInputElement, Props>(
  function ActionSubmit(props: Props, propRef: Ref<HTMLInputElement>) {
    const {
      stylePreset = defaultStylePreset,
      ...htmlInputProps
    } = props

    const formContext = useFormContext()

    const disabled = props.disabled ||
      (formContext ? !formContext.isValid : undefined)

    const className = classNames(
      htmlInputProps.className,
      styles[StylePreset[stylePreset]],
    )

    return (
      <input
        type="submit"
        {...htmlInputProps}
        ref={propRef}
        disabled={disabled}
        className={className}
      />
    )
  },
)
